import React, { FC } from 'react';

import Modal from '~components/atoms/Modal';

import CreateGoldConversionForm from '../CreateGoldConversionForm';

type GoldConversionModalProps = {
    isOpen: boolean;
    onClose: () => void;
}

const GoldConversionModal: FC<GoldConversionModalProps> = ({
    isOpen,
    onClose,
}) => {

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title='Create Gold Conversion'
        >
            <CreateGoldConversionForm />
        </Modal>
    );
};

export default GoldConversionModal;
